import { Component, Input, OnInit } from '@angular/core';
import { icon, latLng, marker, tileLayer } from 'leaflet';
import { filter, first } from 'rxjs/operators';
import { CompetitionInitService } from '../../../services/competition-init.service';
import { IEvents } from '../../../../common-page-components/stores/entities-store/events-store';

@Component({
  selector: 'app-competition-location-panel',
  templateUrl: './competition-location-panel.component.html',
  styleUrls: ['./competition-location-panel.component.scss']
})
export class CompetitionLocationPanelComponent implements OnInit {

  /**
   * The competition input for show data in panel.
   *
   * @type {IEvents}
   * @memberof CompetitionLocationPanelComponent
   */
  @Input() competition: IEvents;
  /**
   * Configuration options of leaflet map
   *
   * @memberof BootstrapMembersInformationComponent
   */
  optionsMap = undefined;

  /**
   * Layers of map
   *
   * @memberof BootstrapMembersInformationComponent
   */
  layers = undefined;


  constructor() { }

  ngOnInit() {
    this.configureMap();
  }


  /**
   * A Method for set map values and coordinates when data arrives
   *
   * @memberof BootstrapMembersInformationComponent
   */
  configureMap() {

    if (this.competition && this.competition.Address.Latitude !== undefined) {
      this.optionsMap = {
        layers: [
          tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' })
        ],
        zoom: 15,
        center: latLng(this.competition.Address.Latitude, this.competition.Address.Longitude)
      };
      this.layers = [

        marker([this.competition.Address.Latitude, this.competition.Address.Longitude], {
          icon: icon({
            iconSize: [25, 41],
            iconAnchor: [13, 41],
            iconUrl: '../../../../../../modules/custom/wa_angular/app/assets/marker-icon.png',
            shadowUrl: '../../../../../../modules/custom/wa_angular/app/assets/marker-shadow.png'
          })
        }
        )
      ];
    }
  }


  /**
   * A method for get always an Array of emails if there's any
   *
   * @param {IMemberAssociation} competition
   * @returns
   * @memberof BootstrapMembersInformationComponent
   */
  provideEmail(competition: IEvents) {
    if (competition && competition.Links) {

      if (competition.Links["E-Mail"]) {

        if (competition.Links["E-Mail"] instanceof Array) {

          return competition.Links["E-Mail"]

        } else {

          const string = [competition.Links['E-Mail'] as string];

          if (string.filter(Boolean)) {

            return string

          }

        }
      }
    }
  }


  /**
   * A method to provide the Array of telephones
   *
   * @param {IMemberAssociation} competition
   * @returns
   * @memberof BootstrapMembersInformationComponent
   */
  provideTelephone(competition: IEvents) {
    return [competition.Links.Phone].concat(competition.Links.Mobile).filter(a => a !== undefined);
  }

}
